<template>
    <b-modal :id="modalId" :title="title" modal-class="modal-w-md" v-on:shown="shown">
        <edit-note
            ref="editNote"
            :company-type="companyType"
            :company-id="companyId"
            :usersMentionList="usersMentionList"
            v-on:saved="saved"
        >
        </edit-note>

        <template #modal-footer>
            <b-button variant="primary" size="lg" @click="save"><template v-if="id">Update</template><template v-else>Add</template></b-button>
        </template>
    </b-modal>
</template>

<script>
import EditNote from "@/components/notes/EditNote";

export default {
    components: {
        EditNote,
    },

    props: {
        companyType: String,
        companyId: Number,
        usersMentionList: Array,
        isPreviewList: Boolean,
    },

    data() {
        return {
            id: 0,
        }
    },

    computed: {
        title() {
            if (this.id) {
                return "Edit Note"
            } else {
                return "Add Note"
            }
        },
        modalId() {
            return this.isPreviewList ? "modal-edit-note-preview" : "modal-edit-note"
        }
    },

    methods: {
        open(id) {
            this.id = id
            this.$bvModal.show(this.modalId)
        },

        shown() {
            this.$refs.editNote.init(this.id)
        },

        save() {
            this.$refs.editNote.save()
        },

        saved() {
            this.$emit('saved')
            this.$bvModal.hide(this.modalId)
        },
    }
}
</script>

<style scoped>

</style>
